module.exports = __webpack_public_path__ + "static/faro-calendar2021-08f23c9e111c9d2aad94e112b02f6bd4.jpg";